import { Grid, Table, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import { MoreHoriz, ImportExport } from '@mui/icons-material';
import {
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Typography,
  Tooltip,
} from '@mui/material';
import React, { useMemo, useState } from 'react';
import { CustomFieldType, getTableCell, TableHeaderCell, TableHeaderContent } from '../../common/DxTable/DxTableCommon';
import { ImageIcon } from '../../utils/UtilsComponent';
import Select from '../../common/Select/Select';
import { useSelector } from 'react-redux';
import AddIcon from '../../assets/icons/add-circle.svg';
import DeleteIcon from '../../assets/icons/delete-icon.svg';
import EditIcon2 from '../../assets/icons/edit-icon-2.svg';
import EditIcon from '../../assets/icons/edit-icon.svg';
import SearchIcon from '../../assets/icons/search-icon.svg';
import LocationIcon from '../../assets/icons/location-icon.svg';
import { Input } from '../../common';
import Button from '../../common/button/Button';
import useModalConfirm from '../../hooks/useModalConfirm';
import ModalEditTags from '../vehicle-wrapper/ModalEditTags';
import { LocationType, selectLocation } from '../../state/modules/location/locationReducer';
import ModalAdd from './ModalAdd';
import ModalEdit from './ModalEdit';
import { useDeleteLocationMutation } from '../../services/location.service';
import { useAuth } from '../../hooks/useAuth';
import dayjs from 'dayjs';
import ModalEditLatLng from './ModalEditLatLng';
import { useSnackbar } from '../../hooks/useSnackbar';
import { useQueryParams, StringParam } from 'use-query-params';
import { useGetAllAgenciesQuery } from 'services/agencies.service';
import { BusinessTypes } from 'configs/constant';
import { IGatewayType } from '../../services/gateway.service';
import { useGetProvincesQuery } from '../../services/geography.service';
import RowActionCommon from '../../common/RowActions/RowActionCommon';
import * as XLSX from 'xlsx';
import { BASE_URL } from 'services/http.service';
import { useNavigate } from 'react-router-dom';
import { ROUTE_CONTROL } from 'utils/routesMap';

interface FiltersFormValue {
  agencyId: string;
  business: string;
}

const ActionCellContent = ({
  cellProps,
  onActionClick,
}: {
  cellProps: Table.DataCellProps;
  onActionClick: (type: string, id: string | any) => void;
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event: {}, _reason: 'backdropClick' | 'escapeKeyDown') => {
    if (event && 'stopPropagation' in event) {
      (event as React.MouseEvent<HTMLElement>).stopPropagation();
    }
    setAnchorEl(null);
  };

  const row = useMemo(() => cellProps.row, [cellProps]);

  const handleClickAction = (type: string, row: any) => {
    handleClose({}, 'backdropClick');
    onActionClick(type, row);
  };

  return (
    <div data-cell-action>
      <IconButton
        id="demo-positioned-button"
        aria-controls={open ? 'demo-positioned-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <MoreHoriz />
      </IconButton>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={() => handleClickAction('view', row)} sx={{ padding: '16px' }}>
          <ListItemIcon>
            <ImageIcon image={LocationIcon} />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ sx: { fontSize: '14px' } }}>Tới vị trí trên bản đồ</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleClickAction('edit', row)} sx={{ padding: '16px' }}>
          <ListItemIcon>
            <ImageIcon image={EditIcon} />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ sx: { fontSize: '14px' } }}>Chỉnh sửa thông tin vị trí</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleClickAction('editLatLng', row)} sx={{ padding: '16px' }}>
          <ListItemIcon>
            <ImageIcon image={EditIcon2} />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ sx: { fontSize: '14px' } }}>Chỉnh sửa toạ độ vị trí</ListItemText>
        </MenuItem>
        <Divider sx={{ margin: '0 16px !important' }} />
        <MenuItem onClick={() => handleClickAction('delete', row)} sx={{ padding: '16px' }}>
          <ListItemIcon>
            <ImageIcon image={DeleteIcon} />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ sx: { fontSize: '14px', color: '#E5401C' } }}>
            Xoá đơn vị
          </ListItemText>
        </MenuItem>
      </Menu>
    </div>
  );
};

export const DeployLocationTable = ({
  refetch,
  gatewayTypes,
}: {
  refetch: () => void;
  gatewayTypes: IGatewayType[];
}) => {
  const [query, setQuery] = useQueryParams({
    agencyId: StringParam,
    search: StringParam,
    business: StringParam,
  });
  const [deleteLocation] = useDeleteLocationMutation();
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [showModalEditLatLng, setShowModalEditLatLng] = useState(false);
  const [editTag, setEditTag] = useState<LocationType>();
  const [selectedLocationId, setSelectedLocationId] = useState<string>();
  const { showModalConfirm, hideModalConfirm } = useModalConfirm();
  const defaultFiltersFormValue = {
    agencyId: query.agencyId || 'all',
    business: query.business || 'all',
  };

  const [filtersFormValue, setFiltersFormValue] = React.useState(defaultFiltersFormValue);
  const [searchValue, setSearchValue] = React.useState(query.search || '');
  const locations = useSelector(selectLocation);
  const { setSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const {
    auth: { currentUser, currentAgency },
  } = useAuth();

  const { data: allAgenciesData } = useGetAllAgenciesQuery({ id: currentUser?.sub_id || '' });
  const agencies = (allAgenciesData?.data || [])
    .concat(currentAgency ? [currentAgency] : [])
    .map((item) => ({ value: item.id, label: item.name }));

  const businessTypes = BusinessTypes.map((item) => ({ label: item.value, value: item.value }));
  const gatewayTypesList = (gatewayTypes || []).map((item) => ({ id: item.id, name: item.name }));
  const { data: provincesData = [] } = useGetProvincesQuery();
  const [columns] = useState([
    { name: 'name', title: 'Tên vị trí' },
    { name: 'addressString', title: 'Địa chỉ' },
    { name: 'business', title: 'Loại hình KD' },
    { name: 'contact_name', title: 'Người liên hệ' },
    { name: 'contact_number', title: 'SĐT người liên hệ' },
    { name: 'gatewayType', title: 'Loại Gateway' },
    { name: 'gatewaySerial', title: 'Serial' },
    { name: 'maintaint_date', title: 'Ngày bảo trì' },
    { name: 'tags', title: 'Thẻ tag' },
    { name: 'action', title: 'Hành động' },
  ]);

  const [tableColumnExtensions] = useState<Table.ColumnExtension[]>([
    { columnName: 'name', width: 300 },
    { columnName: 'addressString', width: 450 },
    { columnName: 'business', width: 250 },
    { columnName: 'action', width: 120, align: 'center' },
    { columnName: 'event_receiver_count', align: 'center' },
    { columnName: 'tags', width: 200 },
    { columnName: 'maintaint_date', width: 200 },
    { columnName: 'contact_number', width: 145 },
    { columnName: 'contact_name', width: 160 },
    { columnName: 'gatewaySerial', width: 160 },
    { columnName: 'gatewayType', width: 200 },
  ]);

  const [customField] = useState<CustomFieldType>({
    tags: {
      renderContent: ({ row }) => {
        if (!row?.tags) return '--';
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography
              sx={{
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                fontSize: '14px',
                color: '#1AA6EE',
              }}
            >
              {row?.tags.join(', ')}
            </Typography>
            <IconButton onClick={() => setEditTag(row)}>
              <ImageIcon image={EditIcon2} />
            </IconButton>
          </Box>
        );
      },
    },
    maintaint_date: {
      renderContent: ({ row }) => {
        return (
          <Typography sx={{ fontSize: '14px', fontWeight: '400' }}>
            {row.maintaint_date ? dayjs(row.maintaint_date)?.format('DD/MM/YYYY') : '--'}
          </Typography>
        );
      },
    },
    addressString: {
      renderContent: ({ row }) => {
        const provinceName = provincesData.find((item: any) => item.code === row.province)?.name || row.province;
        const displayAddress = [row.address, row.commune, provinceName].filter(Boolean).join(', ');
        return (
          <Tooltip title={displayAddress}>
            <Typography sx={{ fontSize: '14px', fontWeight: '400' }}>{displayAddress || '--'}</Typography>
          </Tooltip>
        );
      },
    },
    gatewaySerial: {
      renderContent: ({ row }) => {
        return <Typography sx={{ fontSize: '14px', fontWeight: '400' }}>{row.gateway?.serial || '--'}</Typography>;
      },
    },
    name: {
      renderContent: ({ row }) => {
        return (
          <Tooltip title={row.name}>
            <Typography sx={{ fontSize: '14px', fontWeight: '400' }}>{row.name || '--'}</Typography>
          </Tooltip>
        );
      },
    },
    gatewayType: {
      renderContent: ({ row }) => {
        return (
          <Tooltip title={row.name}>
            <Typography sx={{ fontSize: '14px', fontWeight: '400' }}>
              {mappingGatewayType(row.gateway.type_id)}
            </Typography>
          </Tooltip>
        );
      },
    },
  });

  const mappingGatewayType = (typeId: string) => {
    const type = gatewayTypesList.find((item) => item.id === typeId);
    return type ? `${type.name}` : '--';
  };

  const handleClick = (type: string, row: any) => {
    if (type === 'view') {
      goToMap(row.id);
      return;
    }
    if (type === 'edit') {
      setSelectedLocationId(row.id);
      setShowModalEdit(true);
    }
    if (type === 'editLatLng') {
      setSelectedLocationId(row.id);
      setShowModalEditLatLng(true);
      return;
    }

    if (type === 'delete') {
      showModalConfirm({
        type: 'warning',
        title: 'Xoá vị trí triển khai',
        content: 'Bạn có chắc chắn muốn xoá vị trí này không?',
        confirm: {
          action: () => {
            deleteLocation({ id: row?.id, parent_uuid: currentUser?.sub_id })
              .then((res: any) => {
                if (res?.data?.success === true) {
                  setSnackbar({ open: true, message: 'Xoá vị trí thành công', severity: 'success' });
                  refetch();
                } else {
                  setSnackbar({ open: true, message: 'Có lỗi khi xoá vị trí', severity: 'error' });
                }
              })
              .catch(() => setSnackbar({ open: true, message: 'Có lỗi khi xoá vị trí', severity: 'error' }));

            hideModalConfirm();
          },
          text: 'Xoá vị trí',
        },
        cancel: {
          action: hideModalConfirm,
        },
      });
    }
  };

  const rowActions = [
    {
      icon: <ImageIcon image={LocationIcon} />,
      title: 'Tới vị trí trên bản đồ',
      onClick: (row: any) => handleClick('view', row),
    },
    {
      icon: <ImageIcon image={EditIcon} />,
      title: 'Chỉnh sửa thông tin vị trí',
      onClick: (row: any) => handleClick('edit', row),
    },
    {
      icon: <ImageIcon image={EditIcon2} />,
      title: 'Chỉnh sửa tọa độ vị trí',
      onClick: (row: any) => handleClick('editLatLng', row),
    },
    {
      icon: <ImageIcon image={DeleteIcon} />,
      title: 'Xóa đơn vị',
      onClick: (row: any) => handleClick('delete', row),
    },
  ];

  const goToMap = (id: string) => {
    const cbx = locations.find((item) => item.id === id);
    if (!cbx || !cbx.id) return;
    navigate(`${ROUTE_CONTROL}?tab=0&locationId=${cbx.id}`);
  };

  const handleFilter = () => {
    setQuery({
      agencyId: filtersFormValue.agencyId,
      search: searchValue ? searchValue : undefined,
      business: filtersFormValue.business,
    });
  };

  const handleClearFilter = () => {
    setFiltersFormValue({ agencyId: 'all', business: 'all' });
    setSearchValue('');
    setQuery({
      agencyId: undefined,
      search: undefined,
      business: undefined,
    });
  };

  const handleChange = (filterName: 'agencyId' | 'business', value: any) => {
    setFiltersFormValue({
      ...filtersFormValue,
      [filterName]: value,
    } as FiltersFormValue);
  };

  const handleExport = async () => {
    const token = localStorage.getItem('access_token');
    if (!currentUser || !token) return;
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${JSON.parse(token)}`);
    const URL_CONTENT = currentUser.type === 'organization' ? `locations/export` : `agencies/${currentUser.sub_id}/locations/export`;

    try {
      const response = await fetch(`${BASE_URL}/${URL_CONTENT}`, {
        method: 'GET',
        headers: myHeaders,
      });

      if (!response.ok) throw new Error('Failed to fetch the CSV file');
      const csvText = await response.text();
      const workbook = XLSX.read(csvText, { type: 'string' });
      XLSX.writeFile(workbook, 'locationData.xlsx');
    } catch (error) {
      console.log(error);
    }
  };

  const onSearchChange = (e: any) => {
    const value = e.target.value;
    setSearchValue(value);
  };

  return (
    <>
      {editTag && (
        <ModalEditTags show location={editTag} onClose={() => setEditTag(undefined)} handleSuccess={refetch} />
      )}
      <ModalAdd show={showModalAdd} onClose={() => setShowModalAdd(false)} />
      {selectedLocationId && currentUser && showModalEdit && (
        <ModalEdit
          show={showModalEdit}
          onClose={() => setShowModalEdit(false)}
          locationId={selectedLocationId}
          agencyId={currentUser.sub_id}
        />
      )}
      {selectedLocationId && currentUser && showModalEditLatLng && (
        <ModalEditLatLng
          show={showModalEditLatLng}
          onClose={() => setShowModalEditLatLng(false)}
          locationId={selectedLocationId}
          agencyId={currentUser.sub_id}
        />
      )}

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
        <Box display="flex" alignItems="center">
          <Input
            noMarginTop
            topLable="Tìm kiếm"
            style={{ width: 311, background: '#FFFFFF' }}
            placeholder="Tìm kiếm tên"
            iconStartAdorment={<ImageIcon image={SearchIcon} />}
            onChange={onSearchChange}
            value={searchValue}
            onKeyDown={(ev) => {
              if (ev.key === 'Enter') {
                handleFilter();
                ev.preventDefault();
              }
            }}
          />
          <Box ml={2} display="flex" alignItems="flex-end">
            <Select
              noMarginTop
              fullWidth
              data={agencies}
              selected={filtersFormValue.agencyId}
              setSelected={(data) => handleChange('agencyId', data)}
              style={{ width: '200px', marginRight: '16px' }}
              topLable="Đại lý"
              placeholder="Tất cả đại lý"
            />
            <Select
              fullWidth
              noMarginTop
              data={businessTypes}
              selected={filtersFormValue.business}
              setSelected={(data) => handleChange('business', data)}
              style={{ width: '200px', marginRight: '16px' }}
              topLable="Loại hình kinh doanh"
              placeholder="Tất cả loại hình kinh doanh"
            />
            <Button
              onClick={handleFilter}
              color="primary"
              variant="contained"
              style={{
                height: '40px',
                padding: '0 16px',
                marginRight: '16px',
              }}
            >
              Lọc
            </Button>
            <Button
              onClick={handleClearFilter}
              color="primary"
              variant="outlined"
              style={{ height: '40px', padding: '0 16px' }}
            >
              Xoá bộ lọc
            </Button>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px' }} pt={3.5}>
          {currentUser?.type !== 'organization' && (
            <Button variant="contained" onClick={() => setShowModalAdd(true)}>
              <ImageIcon image={AddIcon} />
              <Box sx={{ marginLeft: '8px' }}>Thêm vị trí triển khai</Box>
            </Button>
          )}

          <Button variant="contained" onClick={() => handleExport()} startIcon={<ImportExport />}>
            <Box sx={{ marginLeft: '8px' }}>Xuất Excel</Box>
          </Button>
        </Box>
      </Box>
      <Paper sx={{ boxShadow: 'none', position: 'relative' }}>
        <Grid rows={locations} columns={columns}>
          <Table
            columnExtensions={tableColumnExtensions}
            cellComponent={(props) =>
              getTableCell(props, <ActionCellContent cellProps={props} onActionClick={handleClick} />, customField)
            }
            rowComponent={(props) => <RowActionCommon {...props} actions={rowActions} />}
          />
          <TableHeaderRow cellComponent={TableHeaderCell} contentComponent={TableHeaderContent} />
        </Grid>
      </Paper>
    </>
  );
};